/**
 * Google Calendar's fixed event color palette (colors().events resource — stable
 * across all accounts). EventModal's color picker must offer exactly these so that
 * editing a Google-synced event doesn't silently replace its real color with an
 * arbitrary app color that has no Google colorId equivalent.
 *
 * IMPORTANT: the hex values here must stay byte-for-byte identical to
 * `GOOGLE_EVENT_COLORS` in `functions/src/scheduled/syncGoogleCalendar.ts`. The two
 * can't share a module (functions/ deliberately doesn't depend on web app code — see
 * project memory on Cloud Build/npm constraints), so keep them in sync by hand.
 */
export interface GoogleEventColor {
  id: string;
  name: string;
  hex: string;
}

export const GOOGLE_EVENT_COLORS: GoogleEventColor[] = [
  { id: '1', name: 'Lavender', hex: '#7986cb' },
  { id: '2', name: 'Sage', hex: '#33b679' },
  { id: '3', name: 'Grape', hex: '#8e24aa' },
  { id: '4', name: 'Flamingo', hex: '#e67c73' },
  { id: '5', name: 'Banana', hex: '#f6c026' },
  { id: '6', name: 'Tangerine', hex: '#f5511d' },
  { id: '7', name: 'Peacock', hex: '#039be5' },
  { id: '8', name: 'Graphite', hex: '#616161' },
  { id: '9', name: 'Blueberry', hex: '#3f51b5' },
  { id: '10', name: 'Basil', hex: '#0b8043' },
  { id: '11', name: 'Tomato', hex: '#d60000' },
];

export const DEFAULT_EVENT_COLOR = GOOGLE_EVENT_COLORS[8]; // Blueberry — closest to the old brand blue (#5e88fc)

export const colorIdForHex = (hex?: string): string | undefined =>
  hex ? GOOGLE_EVENT_COLORS.find((c) => c.hex.toLowerCase() === hex.toLowerCase())?.id : undefined;

export const hexForColorId = (colorId?: string): string | undefined =>
  colorId ? GOOGLE_EVENT_COLORS.find((c) => c.id === colorId)?.hex : undefined;
